import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ standalone: false, name: 'pluralize' })
export class PluralizePipe implements PipeTransform {
  transform(count: number, pluralForm: string = 's', singularForm: string = ''): string {
    return count > 1 ? pluralForm : singularForm;
  }
}
